import React from "react";

interface SizeProps {
  height?: string;
  width?: string;
  color?: string;
}

export default function EthIcon(props: SizeProps) {
  const color = props.color ?? "#252525";
  return (
    <svg
      width={props.height ? props.height : "30px"}
      height={props.width ? props.width : "30px"}
      viewBox="0 0 42 42"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Designs" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          id="Mobile---Transactions:-Trade-Detail---Note-saved"
          transform="translate(-46.000000, -725.000000)"
          stroke={color}
          strokeWidth="1.5"
        >
          <g id="Group" transform="translate(47.000000, 726.000000)">
            <path
              d="M40,20 C40,31.0458 31.0458,40 20,40 C8.9542,40 0,31.0458 0,20 C0,8.9542 8.9542,0 20,0 C31.0458,0 40,8.9542 40,20"
              id="Circle"
            ></path>
            <g
              transform="translate(8.500000, 11.000000)"
              id="Icons-/-Line-/-Note"
              strokeLinejoin="round"
            >
              <g>
                <path
                  d="M1.95660415,18 L1.95660415,18 C0.87600675,18 0,17.1240003 0,16.0434 L0,10.8585 C-0.000948589717,10.6762303 0.0707869448,10.501097 0.199334249,10.3718737 C0.327881553,10.2426503 0.50263587,10.17 0.684907612,10.17 L3.91320215,10.17 L3.91320215,16.0398 C3.91415476,16.559346 3.7084362,17.0579403 3.34139986,17.4256529 C2.97436352,17.7933656 2.47614967,18 1.95660415,18 L1.95660415,18 Z"
                  id="Path"
                ></path>
                <path
                  d="M3.91319883,11.1915 L3.91319883,0.8001 C3.91079826,0.590283227 3.9918522,0.388107796 4.13852692,0.238056962 C4.28520163,0.088006129 4.48548019,0.00237341785 4.6952967,0 L21.7169504,0 C21.9269237,0.00213630148 22.1274332,0.0876647568 22.2743021,0.237741488 C22.4211709,0.387818219 22.502348,0.590128953 22.5,0.8001 L22.5,15.0003 C22.5,16.6572 21.1859518,18 19.5650563,18 L1.95660415,18"
                  id="Path"
                ></path>
                <line
                  x1="8.31508686"
                  y1="6.2663"
                  x2="17.1197629"
                  y2="6.2663"
                  id="Path"
                  strokeLinecap="round"
                ></line>
                <line
                  x1="8.31508686"
                  y1="9.6899"
                  x2="19.0763576"
                  y2="9.6899"
                  id="Path"
                  strokeLinecap="round"
                ></line>
                <line
                  x1="8.31508686"
                  y1="13.1135"
                  x2="15.1631682"
                  y2="13.1135"
                  id="Path"
                  strokeLinecap="round"
                ></line>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}
